import { Component, ViewChild } from '@angular/core';

import { Subject } from 'rxjs';

import { TranslatePipe } from '@core/i18n-legacy';
import type { AlignValue, FigureContextAction } from '@core/prosemirror-legacy';
import type { IconName } from '@core/user-interface-legacy';
import {
  ButtonComponent,
  ButtonDropdownIndicatorDirective,
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownWidth,
  IconButtonComponent,
  IconComponent,
  OverlayOriginDirective,
  RtTooltip,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-figure-context-menu',
  templateUrl: './figure-context-menu.component.html',
  styleUrl: './figure-context-menu.component.less',
  imports: [
    ButtonComponent,
    DropdownComponent,
    IconButtonComponent,
    OverlayOriginDirective,
    ConnectedOverlayDirective,
    IconComponent,
    ButtonDropdownIndicatorDirective,
    TranslatePipe,
    RtTooltip,
  ],
})
export class FigureContextMenuComponent {
  public readonly DropdownWidth = DropdownWidth;

  public action$ = new Subject<FigureContextAction>();

  public getAlign?: () => AlignValue | undefined;

  @ViewChild(ConnectedOverlayDirective, { static: false })
  public alignmentDropdown: ConnectedOverlayDirective;

  public get align() {
    return this.getAlign ? this.getAlign() : undefined;
  }

  public get alignIcon(): IconName {
    switch (this.align) {
      case 'right':
        return 'burst-mode';
      case 'center':
        return 'image-align-center';
      case 'left':
      default:
        return 'art-track';
    }
  }

  public edit() {
    this.action$.next({ type: 'edit' });
  }

  public resetSize() {
    this.action$.next({ type: 'resetSize' });
  }

  public setAlign(value: AlignValue) {
    this.action$.next({ type: 'align', value });
  }

  public delete() {
    this.action$.next({ type: 'delete' });
  }

  public afterUpdatePosition() {
    this.alignmentDropdown?.updatePosition();
  }
}
